<template>
    <div>
        <div class="right-box">
            <div class="right-title">
                <span>热门投诉</span>
                <a href="/Index/complain.html" target="_blank">我要投诉</a>
            </div>
            <ul class="platform">
                <li
                v-for="(i, index) of platform"
                :key="index"
                @click="getPlatform(index)">
                    {{i}}
                    <i class="fa fa-fire fa-lg"></i>
                </li>
            </ul>
        </div>

        <div class="right-box">
            <div class="right-title">
                <span>地方站</span>
            </div>
            <ul class="platform">
                <li
                v-for="(i, index) of stand"
                :key="index"
                @click="toStand(i.code)">
                    {{i.name}}
                </li>
            </ul>
        </div>

        <Email/>
        <div class="right-box">
            <div class="right-title">
                <span>关注我们</span>
            </div>
            <div class="we-media">
                <a>
                    <ul class="wx">
                        <li>
                            <div class="we-icon">
                                <img :src="require('@/assets/wx.png')">
                                <span>电诉宝</span>
                            </div>
                        </li>
                        <img class="wx-show" src="//imgs-b2b.toocle.com/Public/home/images/complain/wx.jpg">
                        <li>微信公众号</li>
                    </ul>
                </a>
                <a
                v-for="(i, index) of media"
                :key="index"
                :href="i.url"
                target="_blank">
                    <ul :class="i.icon">
                        <li>
                            <div class="we-icon">
                                <img :src="require('@/assets/' + i.icon + '.png')">
                                <span>{{i.we}}</span>
                            </div>
                        </li>
                        <li>{{i.name}}</li>
                    </ul>
                </a>
            </div>
        </div>
        <div style="width: 365px">
        <a href="https://www.100ec.cn/zt/wswjsxfpgyl/" target="_blank">
          <img style="width: 100%" src="/Public/home/images/zyttk/xfpjr1.jpg" />
        </a>
      </div>
    </div>
</template>

<script>
export default {
    name: 'ContentR',
    data() {
        return {
            year: '',
            time: '',
            platform: [],
            stand: [],
            media: [],
        }
    },
    mounted() {        
        if(new Date().getMonth >= 2) {
            this.year = new Date().getFullYear()
        }else {
            this.year = new Date().getFullYear() - 1
            this.time = 'whole_year'
        }
        axios.get('https://www.100ec.cn/315/api/index.php?_a=product&f=most_company_list&type=' + this.$store.state.type + '&limit=20&year=' + this.year + '&time=' + this.time)
        .then((res) => {
            for(var i of res.data.list) {
                this.platform.push(i.company)
            }
        })

        this.stand = stand

        this.$store.state.dropList.forEach(item => {
            if(item.name == '电诉宝') {
                this.media = item.child
            }
        })
    },
    methods: {
        getPlatform(index) {
            window.open('/Index/complain_search.html?company=' + this.platform[index])
        },
        toStand(code) {
            window.open('/Index/complain.html?stand=' + code)
        }
    }
}
</script>